/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
import axios from 'axios';

import {
  isResponseValid,
  throwSAPError,
  CustomException,
  getIdToken,
  // isAllResponseValid,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import {
  GET_SHIPPING_TABLE_DATA,
  SET_SHIPPING_TABLE_STATUS,
  GET_SHIP_TO_PARTY_DATA,
  SAVE_DATA,
} from '../helpers/types';

const invalidResponseMsgText = i18n.t('checkoutScreenTranslations:INVALID_RESPONSE');
const getShipmentTypeData = data => {
  try {
    const ShipmentTypeDataArr = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i <= 10; i++) {
      const item = data[`ShippingType${i}`];
      if (item && item !== '') {
        ShipmentTypeDataArr.push(item);
      }
    }

    return ShipmentTypeDataArr;
  } catch (err) {
    return [];
  }
};

export const getShippingTableData = (enqueueSnackbar = () => {}) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, selectedSalesOrgData } = auth;
    const { ConditionType, SalesOrg } = selectedSalesOrgData;
    dispatch({
      type: SET_SHIPPING_TABLE_STATUS,
      payload: { isLoading: true },
    });
    const idToken = await getIdToken(dispatch, getState);

    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
    });

    const shipmentType = {};
    const price = {};
    const shipmentTypeData = getShipmentTypeData(selectedSalesOrgData);
    const shipmentTypeFilterArr = [];
    let shipmentTypeFilter = '';
    shipmentTypeData.forEach(m => {
      shipmentTypeFilterArr.push(`ShipmentType eq '${m}'`);
    });
    if (shipmentTypeFilterArr.length > 0) {
      shipmentTypeFilter = shipmentTypeFilterArr.join(' or ');
    }
    shipmentType.config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $top: 25,
        'sap-client': client,
        $filter: `SalesOrg eq '${SalesOrg}'`,
      },
    };

    price.config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $top: 25,
        'sap-client': client,
        $filter: `SalesOrganization eq '${SalesOrg}' and ConditionType eq '${ConditionType}'`,
      },
    };
    if (shipmentTypeFilter !== '') {
      shipmentType.config = {
        ...shipmentType.config,
        params: {
          ...shipmentType.config.params,
          $filter: `SalesOrg eq '${SalesOrg}' and  (${shipmentTypeFilter})`,
        },
      };
    }

    shipmentType.request = MainService.get('/ZAE_VH_ShipmentType', shipmentType.config);
    if (ConditionType !== '') {
      price.response = await MainService.get(`/ZAE_I_ShipmentCost`, price.config).catch(
        throwSAPError
      );
    } else {
      price.response = { data: { d: { results: [] } }, status: 200 };
    }
    shipmentType.response = await MainService.get(
      `/ZAE_VH_ShipmentType`,
      shipmentType.config
    ).catch(throwSAPError);

    if (isResponseValid(shipmentType.response) && isResponseValid(price.response)) {
      const data = shipmentType.response.data.d.results;
      let payloadData = data;
      const priceData = price.response.data.d.results;
      if (priceData.length > 0) {
        const updateList = data.map(d => {
          let dF = d;
          priceData.forEach(f => {
            if (d.SalesOrg === f.SalesOrganization && d.ShipmentType === f.Vsart) {
              dF = { ...dF, ...f };
            }
            return dF;
          });
          return dF;
        });
        const updateDataArr = updateList.map(p =>
          p.ConditionRateValue === undefined
            ? { ...p, ConditionRateValue: '0.000', ConditionRateValueUnit: 'AED' }
            : p
        );
        payloadData = updateDataArr;
      }
      dispatch({
        type: GET_SHIPPING_TABLE_DATA,
        payload: {
          data: payloadData,
          priceData,
        },
      });
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    dispatch({
      type: SET_SHIPPING_TABLE_STATUS,
      payload: { isLoading: false },
    });

    enqueueSnackbar(i18n.t('checkoutScreenTranslations:UNABLE_TO_LOAD_DATA'), {
      variant: 'error',
    });
  }
};

export const submitCheckout = (
  data,
  history,
  setRequestStatus,
  clearCart,
  enqueueSnackbar = () => {},
  fmName
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { systemIP, selectedSalesOrgData } = auth;

    const { CheckoutRule } = selectedSalesOrgData;
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {
        // 'sap-client': client,
      },
    };
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV/`,
    });

    const response = await MainService.post(fmName, data, config).catch(e => {
      let message = e.toString();
      if (e.response.data.error.message.value) {
        message = e.response.data.error.message.value;
      } else if (e.response.status && e.response.statusText) {
        message = `${e.response.status} - ${e.response.statusText}`;
      }
      enqueueSnackbar(message, {
        variant: 'error',
      });
    });

    if (isResponseValid(response)) {
      setRequestStatus(false);
      clearCart();
      enqueueSnackbar(i18n.t('checkoutScreenTranslations:SUCCESSFULLY_SUBMITTED'), {
        variant: 'success',
      });
      history.push({
        pathname: '/confirmation',
        state: { isConfirm: true },
      });

      dispatch({
        type: SAVE_DATA,
        payload: {
          orderId:
            CheckoutRule === '02'
              ? response.data.d.N_CB2B_SO_HEADER_DATA.results[0].Salesdocument
              : response.data.d.N_ZAE_FM_CB2B_CREATE_SQ.results[0].Salesdocument,
        },
      });
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    console.log(error);
    enqueueSnackbar(i18n.t('authScreenTranslations:SOMETHING_WENT_WRONG'), {
      variant: 'error',
    });
    setRequestStatus(false);
  }
};

export const getShipToPartyData = (enqueueSnackbar = () => {}, filterStr = '') => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, selectedSalesOrgData, BusinessPartner, contactPersonData } = auth;
    const { SalesOrg, DisCha, Division } = selectedSalesOrgData;
    const filterStr1 = contactPersonData
      .map(c => `BusinessPartner eq '${c.ShipToParty}'`)
      .join(' or ');
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $top: 25,
        'sap-client': client,
        $filter: `SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}' and Division eq '${Division}' and ${
          filterStr === '' ? filterStr1 : filterStr
        }`,
      },
    };
    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV`,
    });

    const response = await MainService.get('/ZAE_I_BPPartFuncDetails', config).catch(throwSAPError);
    const shipToPartyData = response.data.d.results.filter(item => item.PartnerFunction === 'SH');
    const uniqueData = Array.from(
      new Map(shipToPartyData.map(item => [item.BusinessPartnerName, item])).values()
    );
    if (isResponseValid(response)) {
      dispatch({
        type: GET_SHIP_TO_PARTY_DATA,
        payload: {
          data: uniqueData,
        },
      });
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('checkoutScreenTranslations:UNABLE_TO_LOAD_SHIP_TO_PART_DETAILS'), {
      variant: 'error',
    });
  }
};
